import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NpsService} from "../../lib/services/nps/nps.service";
import {ToastService} from "../../lib/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'app-nps',
    templateUrl: './nps.component.html',
    styleUrls: ['./nps.component.scss']
})
export class NpsComponent implements OnInit, AfterViewInit {

    @Input() borderRound = false;
    @Input() showCloseIcon = true;
    @Output() onCloseNpsNextQuestion: EventEmitter<any> = new EventEmitter<any>()
    @Output() onCloseNpsSuccess: EventEmitter<any> = new EventEmitter<any>()
    questions;
    mainQuestion;
    nextQuestion: any;
    npsModalVisible = false;
    successModal = false;
    placeholders = {
        "ESAT_P2": {
            placeholder: 'nps.placeholderESAT_P2',
            successTitle: 'nps.npsSuccessTitleESAT_P2',
            successMessage: ''
        },
        "ESAT_P3": {
            placeholder: "nps.placeholderESAT_P3",
            successTitle: 'nps.npsSuccessTitleESAT_P3',
            successMessage: 'nps.npsSuccessMsgESAT_P3'
        },
    }
    loadingButton = false;
    requestComment = ''
    visible = false;

    constructor(private npsService: NpsService,
                private toastService: ToastService,
                private translateService: TranslateService) {
    }

    ngOnInit() {
        this.questions = this.npsService.questions;
        this.getMainQuestion();
    }

    ngAfterViewInit() {
    }

    getMainQuestion() {
        this.mainQuestion = this.questions?.find(question => question.code === 'ESAT_P1');
    }

    getNextQuestion(option) {
        let code = ''
        if (option <= 2) {
            code = 'ESAT_P2'
        } else if (option >= 3) {
            code = 'ESAT_P3'
        }
        this.nextQuestion = this.questions.find(question => question.code === code)
    }

    async selectOption(item: any) {
        try {
            const idQuestion = this.mainQuestion.idQuestion;
            const option = item.option;
            await firstValueFrom(this.npsService.sendNpsRequest(idQuestion, option))
            this.getNextQuestion(item.option)
            this.npsModalVisible = true
        } catch (e) {
            console.error('Error')
        }
    }

    closeNps() {
        this.npsService.closeNps();
    }

    closeNpsModal() {
        this.npsModalVisible = false;
        this.requestComment = '';
        this.onCloseNpsNextQuestion.emit();
    }

    async sendNpsRequest() {
        try {
            this.loadingButton = true;
            const idQuestion = this.nextQuestion.idQuestion;
            const option = this.requestComment;
            await firstValueFrom(this.npsService.sendNpsRequest(idQuestion, option))
            this.loadingButton = false;
            this.successModal = true;
            this.npsModalVisible = false;
        } catch (e) {
            console.error(e);
            this.showErrorMessage().catch();

        } finally {
            this.loadingButton = false;
        }

    }

    async showErrorMessage() {
        const message = await firstValueFrom(this.translateService.get('nps.error'));
        this.toastService.showToast(message)
    }

    closeSuccessNpsModal() {
        this.successModal = false;
        this.npsService.showNps = false;
        this.onCloseNpsSuccess.emit()
    }

    showDialog() {
        this.visible = true
    }
}
